export const texts = {
  title: {
    de: 'Einladungslink anfordern',
    en: 'Request invitation link'
  },
  introBefore: {
    de: 'Sie müssen sich zunächst im skillconomy-Portal registrieren. Hierzu erhalten Sie von uns einen Link per Mail an',
    en: 'You first need to register in the skillconomy portal. We will send you a link by email to'
  },
  introAfter: {
    de: 'über den Sie zur Registrierung gelangen.',
    en: 'which will take you to the registration.'
  },
  sendError: {
    de: 'Der Link konnte nicht zugesendet werden. Bitte wenden Sie sich an skillconomy.',
    en: 'The link could not be sent. Please contact skillconomy.'
  },
  sendSuccess: {
    de: 'Der Link wurde versendet. Bitte schauen Sie auch im Spam-Ordner.',
    en: 'The link has been sent. Please also check your spam folder.'
  },
  submit: {
    de: 'Link zusenden',
    en: 'Send link'
  },
  hasAccount: {
    de: 'Sie haben bereits einen Account?',
    en: 'Already have an account?'
  },
  signIn: {
    de: 'Anmelden',
    en: 'Sign in'
  }
};
